import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_MAIL_FOLDERS } from '@/api/endpoints';
import { MAIL_FOLDERS_QUERY_KEY } from '@/api/queryKeys';
import type { MailFolder } from '@/types/mail';
import { unwrapAxiosResponse } from '@/utils/axios';

export const useMailFolders = (isEnabled: boolean) =>
  useQuery<MailFolder[]>({
    queryKey: MAIL_FOLDERS_QUERY_KEY,
    queryFn: () =>
      apiClient
        .get<MailFolder[]>(API_MAIL_FOLDERS)
        .then(unwrapAxiosResponse)
        .then((folders) =>
          folders.map((folder) => ({
            ...folder,
            searchTypes: folder.searchTypes ?? [],
            actions: folder.actions ?? [],
          })),
        ),
    enabled: isEnabled,
  });
